module.exports = __webpack_public_path__ + "static/media/linkedin_button.b43688da.svg";